<script setup lang="ts">
import { computed } from 'vue';

import {
  METRIC_TABLE_REPORTS,
  NARROW_PLACEHOLDER_REPORTS,
} from '@/app/dashboards/utils/reports.enum';
import NarrowReportPlaceholder from '@/components/VisionAi/chat-panel-components/widgets/NarrowReportPlaceholder.vue';
import LegacyDashboardReportsWidget from '@/components/VisionAi/widgets/LegacyDashboardReportsWidget.vue';
import type { LegacyDashboardReportData } from '@/components/VisionAi/widgets/visionWidget.types';

const { widgetData, narrowMode = false } = defineProps<{
  widgetData: LegacyDashboardReportData;
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  expand: [];
}>();

const reportDataForcedExpanded = computed(() => ({
  ...widgetData,
  isExpanded: true,
  narrowMode,
}));

const reportType = computed(() => widgetData.type);

const isTable = computed(
  () => !!reportType.value && METRIC_TABLE_REPORTS.includes(reportType.value),
);
const isPlaceholder = computed(
  () => narrowMode && !!reportType.value && NARROW_PLACEHOLDER_REPORTS.includes(reportType.value),
);
</script>

<template>
  <NarrowReportPlaceholder
    v-if="isPlaceholder"
    :widget-data="widgetData"
    @expand="emit('expand')"
  />
  <div
    v-else-if="narrowMode && isTable"
    class="w-full max-w-full overflow-x-auto"
    data-test="NarrowableDashboardReport-TableScroll"
  >
    <LegacyDashboardReportsWidget :widget-data="reportDataForcedExpanded" />
  </div>
  <LegacyDashboardReportsWidget v-else :widget-data="reportDataForcedExpanded" />
</template>
